import { render, staticRenderFns } from "./WxJsPay.vue?vue&type=template&id=a9bf993c"
import script from "./WxJsPay.vue?vue&type=script&lang=js"
export * from "./WxJsPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.27_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_bg3kgbxtkzfehr6b2f7ajf354m/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports